import axios from 'axios';

const clienteAxios = axios.create({
    baseURL : process.env.REACT_APP_BACKEND_URL,
    timeout: 60000
});

// Una sola sesión por cuenta: si el servidor ya no reconoce el token (porque se entró desde otro
// equipo o venció), se limpia y se vuelve al login con un aviso claro.
clienteAxios.interceptors.response.use(
    (r) => r,
    (error) => {
        const st = error.response && error.response.status;
        const url = (error.config && error.config.url) || '';
        const hayToken = typeof window !== 'undefined' && localStorage.getItem('token');
        if (st === 401 && hayToken && url.indexOf('/authenticate') === -1) {
            try {
                localStorage.removeItem('token');
                sessionStorage.setItem('p7_sesion_cerrada', '1');
            } catch (e) { /* sin storage: seguimos */ }
            if (window.location.pathname !== '/portal') window.location.assign('/portal');
        }
        return Promise.reject(error);
    }
);

export default clienteAxios;
